import React, { useEffect, useState } from "react";

import { useAppSelector } from "../../redux/hooks";
import { useLazyGetEditsQuery } from "../../redux/slices/synergy-api/synergy-api";
import { SynergyClip, SynergyEdit } from "../../redux/slices/synergy-api/types";
import { Button } from "../Button/button";
import { Modal } from "../modal/modal";
import { Table } from "../table/table";
import styles from "./synergy-video-dialog.module.scss";
import { useSynergyClipManager } from "./use-synergy-clip-manager";

export interface SynergyVideoDialogProps {
  open: boolean;
  onClose: () => void;
  uploadClips: (clips: SynergyClip[]) => void;
}

export const SynergyVideoDialog = ({ open, onClose, uploadClips }: SynergyVideoDialogProps) => {
  const auth = useAppSelector((state) => state.auth);
  const [edits, setEdits] = useState<SynergyEdit[]>([]);

  const [getEdits] = useLazyGetEditsQuery();

  const {
    EditsToRows,
    ClipsToRows,
    handleSelectAll,
    handleSelectClip,
    handleCancelClipSelection,
    handleFinishClipSelection,
    handleCancelAttachmentSelection,
    handleFinishAttachmentSelection,
    setSelectedEdit,
    selectedClips,
    clips,
    handleClose,
    clipsActionTaken,
    playActionTaken,
    clipsToAttach,
  } = useSynergyClipManager({ uploadClips, edits, onClose });

  useEffect(() => {
    const fetchEdits = async () => {
      const edits = await (await getEdits({ accessToken: auth.token || "" }).unwrap()).results;
      setEdits(edits);
    };

    if (open) {
      fetchEdits();
    }
  }, [auth.token, getEdits, open]);

  let content;
  if (clips) {
    content = (
      <Table
        data={ClipsToRows({ clips })}
        handleRowClick={handleSelectClip}
        selected={ClipsToRows({ clips: selectedClips })}
        handleSelectAll={handleSelectAll}
      />
    );
  } else {
    // show table of edits
    content = <Table data={EditsToRows()} handleRowClick={(row) => setSelectedEdit(row)} />;
  }

  let actions;
  if (clips) {
    // show actions to confirm clip selection or cancel
    actions = [
      <Button text="Cancel" onClick={handleCancelClipSelection} minimal={true} key={1} />,
      <Button intent="primary" text="Done" onClick={handleFinishClipSelection} key={2} disabled={clipsActionTaken} />,
    ];
  } else {
    // show actions to add selected clips to play or cancel
    actions = [
      <Button text="Cancel" onClick={handleCancelAttachmentSelection} minimal={true} key={1} />,
      <Button
        intent="primary"
        text={`Add ${clipsToAttach.length} Clips`}
        onClick={handleFinishAttachmentSelection}
        key={2}
        disabled={playActionTaken}
      />,
    ];
  }

  return (
    <Modal isOpen={open} onClose={handleClose} style={{ width: "90%" }} title="SYNERGY CLIPS" actions={actions}>
      <div className={styles.synergyVideoContainer}>{content}</div>
    </Modal>
  );
};
